<template>
    <div class="Terms">
        <!-- s: header -->
        <header id="header-slidePanel">
            <h2>정보 및 약관</h2>
            <div class="btn_back">
                <a @click="slidePanelClose"><img src="@/assets/images/btn_back.png" width="50" alt="이전" /></a>
            </div>
        </header>
        <!-- e: header -->
        <!-- s: contents -->
        <div class="contents-area-slidePanel">
            <div class="scroll-tab mrg-btm-20 clearfix">
                <ul>
                    <li :class="result == 'use' ? 'active' : ''">
                        <a @click="result ='use'"><p>이용약관</p></a>
                    </li>
                    <li :class="result == 'personal' ? 'active' : ''">
                        <a @click="result ='personal'"><p>개인정보<br/>취급방침</p></a>
                    </li>
                    <li :class="result == 'community' ? 'active' : ''">
                        <a @click="result ='community'"><p>커뮤니티<br/>운영정책</p></a>
                    </li>
                </ul>
            </div>
            <div class="terms-contents" v-html="useTermsText" v-show="result == 'use'"></div>
            <div class="terms-contents" v-html="personalText" v-show="result == 'personal'"></div>
            <div class="terms-contents" v-html="communityText" v-show="result == 'community'"></div>
        </div>
        <!-- e: contents -->
    </div>
</template>

<script>
export default {
    name: 'Terms',
    props: ['pResult'],
    data() {
        return {
            result:'',          // 선택된 약관정보
            personalText:'',    // 이용약관
            useTermsText:'',    // 개인정보 취급방침
            communityText:'',   // 커뮤니티 운영정책
        }
    },
    // 감시자
    watch: {
    },
    // $el 생성전
    created(){
        this.result = this.pResult;
        // 이용약관
        this.useTermsFunc();
        // 개인정보 취급방침
        this.personalInfoCollectFunc();
        // 커뮤니티 운영정책
        this.useCommunityFunc();
    },
    // $el 생성후
    mounted() {
        window.callbackBackKey = this.callbackBackKey;
    },
    methods: {
        // APP 뒤로가기
        callbackBackKey(){
            this.slidePanelClose();
        },
    }
}
</script>

<style scoped>
    .scroll-tab {padding-bottom: 0}
    .scroll-tab li {border-radius: 10px;padding: 0;height: 60px;width: 80px; border: 2px solid #e0e0e0;}
    .scroll-tab li a {color: #969696;font-weight: 400;position: relative;width: 100%;height: 100%;font-size: 14px; }
    .scroll-tab li a p{position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%);text-align: center;}
    .scroll-tab li:last-child {margin-right: 0;}
    .scroll-tab li.active {border: 2px solid #017ff0;background: #fff;}
    .scroll-tab li.active a{color: #017ff0;font-weight: 600}
    .scroll-tab li.active a p{}
    .terms-contents {font-size: 13px; color: #000; line-height: 180%}
</style>
